module.exports = __webpack_public_path__ + "static/media/trash-delivery.2fd55823.png";